import { type Id, toast } from 'react-toastify';
import * as toastStyles from 'ui/styles/toast.module.scss';

export const renderToastPopup = (type: 'error' | 'success', message: string): Id =>
  toast[type](message, { className: toastStyles[type] });
